"use client";

import PromoBanner from "@/components/common/PromoBanner";

export default function PageHeading() {
     return <PromoBanner />;
}